import withAPIAction from 'helpers/withAPIAction'
import { ContentListReq, CreateContentReq, DeleteContentReq, ContentDetailReq, PagenameReq } from './types'
import {
  getContentListAction,
  createContentAction,
  deleteContentAction,
  getContentDetailAction,
  getPagenameListAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const contentListAPI = (data: ContentListReq, token: string, xmid: any) => {
  return withAPIAction<ContentListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.contentList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getContentListAction)
}

export const pagenameListAPI = (data: PagenameReq, token: string, xmid: any) => {
  return withAPIAction<PagenameReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.pagenameList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getPagenameListAction)
}

export const createContentAPI = (data: CreateContentReq, token: string, xmid: string) => {
  return withAPIAction<CreateContentReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createContent,
    data,
    token,
    xmid,
  })(createContentAction)
}

export const deleteContentAPI = (data: DeleteContentReq, token: string, xmid: string) => {
  const endPoint = APIPath.deleteContent.replace(':id', data.id.toString())
  return withAPIAction<DeleteContentReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteContentAction)
}

export const getContentDetailAPI = (data: ContentDetailReq, token: string, xmid: string) => {
  //const endPoint = APIPath.getContentByID.replace(':pagename', data.pagename)
  return withAPIAction<ContentDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.getContentByID}?pagename=${data.pagename}`,
    data,
    token,
    xmid,
  })(getContentDetailAction)
}
